<template>
  <div class="content-card" :class="{ 'blurred-background': !props.noBox }">
    <h2 v-if="props.heading">
      {{ props.heading }}
    </h2>
    <div class="content-card-description" v-if="$slots.description">
      <slot name="description"></slot>
    </div>
    <h3 v-if="props.subheading">
      {{ props.subheading }}
    </h3>
    <div class="content-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
const props = defineProps({
  heading: {
    type: String,
    default: undefined,
  },
  subheading: {
    type: String,
    default: undefined,
  },
  noBox: {
    type: Boolean,
    default: false,
  },
});
</script>

<style>
.content-card {
  width: 100%;
  margin: 0 auto;
  padding: var(--spacing-md);

  display: flex;
  flex-direction: column;

  border-radius: var(--box-border-radius);
}

.content-card:not(.blurred-background) {
  padding: var(--spacing-md) 0;
  border-radius: 0;
}

.content-card.blurred-background {
  transition: transform var(--transition-normal),
    box-shadow var(--transition-normal);
}

.content-card.blurred-background:hover {
  background: var(--box-bg-hover);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.content-card-description {
  margin-bottom: var(--spacing-md);
}

.content-card-body {
  width: 100%;
}

h2 {
  font-size: var(--font-size-xxl);
  color: var(--color-cream);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);
  text-align: left;
  margin: 0 0 var(--spacing-sm) 0;
}

h3 {
  font-size: var(--font-size-xl);
  color: var(--color-cream);
  margin: 0 0 var(--spacing-sm) 0;
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-tight);
  line-height: var(--line-height-compact);
  text-align: left;
}

p {
  font-size: var(--font-size-m);
  color: var(--color-cream);
  line-height: var(--line-height-relaxed);
  margin: 0 0 var(--spacing-sm) 0;
  text-align: left;
  font-weight: var(--font-weight-light);
}

p:last-child {
  margin-bottom: 0;
}

ol {
  list-style-position: inside;
  padding-left: 0;
}

ul {
  padding-inline-start: var(--spacing-md);
  padding-left: 0;
}

li {
  font-size: var(--font-size-m);
  font-weight: var(--font-weight-light);
  color: var(--color-cream);
  line-height: var(--line-height-body);
  align-items: center;
  margin-bottom: var(--spacing-sm);
  text-align: left;
}

li::marker {
  color: var(--color-cream);
  font-weight: var(--font-weight-light);
  opacity: 0.8;
}

ul > li {
  display: flex;
  list-style: none;
  padding-left: 0;
}

ul > li::before {
  margin-right: var(--spacing-sm);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-medium);
  line-height: 1;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .content-card {
    flex-direction: column;
  }

  h2 {
    margin-bottom: var(--spacing-sm);
  }

  h3 {
    margin-bottom: var(--spacing-sm);
  }

  p {
    margin-bottom: var(--spacing-sm);
    line-height: var(--line-height-compact);
  }

  ul > li {
    margin-bottom: var(--spacing-sm);
  }
}

@media (max-width: 480px) {
  .content-card {
    padding: var(--spacing-sm);
  }
}
</style>
